import {Button, withStyles} from '@material-ui/core';

const DefaultButton = withStyles(theme => ({
  root: {
    fontSize: 18,
    color: '#fff',
    background: theme.palette.background.grey,
    // borderRadius: 15,
    fontWeight: 'bolder',
    textDecoration: 'none',
    cursor: 'pointer',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: 1.5,
    '&:hover': {
      background: theme.palette.background.grey,
      boxShadow: 'none',
      outline: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      outline: 'none',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
  },
}))(Button);

export {DefaultButton};
